import React from 'react'
import { Button, Separator } from '@fs/zion-ui'
import { useGroupData } from '../../hooks'
import transl from './GroupDataHeader.transl'
import NavigationButtons from './NavigationButtons'
import useInfoSheetOrientationCachedState from '../../../../../shared/hooks/useInfoSheetOrientationCachedState'

export default function InformationPanel({ onEditClick, showPrevNext = false }) {
  const {
    initialGroup: { types },
  } = useGroupData()

  const { isBottomSheet } = useInfoSheetOrientationCachedState()

  const isVolumeSet = types?.includes('VOLUME_SET')
  const showSwitchItemButton = !isVolumeSet

  return (
    <>
      <Button emphasis="medium" color="blue" fullWidth={!isBottomSheet} onClick={onEditClick}>
        {transl.recordMetadataReviewEditMetadataButton()}
      </Button>
      <Separator size="xxs" />

      {showPrevNext && <NavigationButtons showSwitchItemButton={showSwitchItemButton} />}
    </>
  )
}
